export interface LoginFormFields {
  username: string | null;
  password: string | null;
}

export enum ErrorReason {
  BAD_CREDENTIALS = 'BAD_CREDENTIALS',
  USER_DISABLED = 'USER_DISABLED',
}

export interface LoginError {
  reason: ErrorReason;
  field: string;
}
